import { colors } from "@/styles/colors"
import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles(({
	item: {
		padding: "6px",
		borderRadius: "4px",
		"&:hover": {
			background: colors.gray[100]
		}
	}
}))

export default useStyles
